/**
 * TextareaAutosize - MUI TextareaAutosize Component Wrapper
 * 
 * A thin wrapper around Material-UI TextareaAutosize component for consistent imports.
 */

import MuiTextareaAutosize from "@mui/material/TextareaAutosize";

const TextareaAutosize = (props) => {
  return <MuiTextareaAutosize {...props} />;
};

export default TextareaAutosize;

